import { useSyncExternalStore } from 'react'
import { dataLayerSourceId, subscribeDataLayerSourceId } from '@/lib/dataLayerBase'

/**
 * The named data-layer source in force, or null until the allowlist has
 * answered. Reactive wrapper over the module store in `dataLayerBase` — the
 * store itself stays a plain module because `dataLayerApi` must read it too.
 */
export function useDataLayerSourceId(): string | null {
  return useSyncExternalStore(subscribeDataLayerSourceId, dataLayerSourceId, dataLayerSourceId)
}
